module.exports = __webpack_public_path__ + "img/expand-map.a09a4998.svg";